/**
 * KnowledgeLibrary.tsx — Unified Knowledge Library page
 * Route: /knowledge-library
 * Surfaces the full Knowledge Engine: XBRL, patterns, authority chains,
 * coverage, citations, standards, framework divergences
 */
import useTabState from '../hooks/useTabState';
import PageLayout from '../components/ui/PageLayout';
import TabBar from '../components/ui/TabBar';
import OverviewTab from '../components/knowledge-library/OverviewTab';
import StandardsXBRLTab from '../components/knowledge-library/StandardsXBRLTab';
import ResolutionPatternsTab from '../components/knowledge-library/ResolutionPatternsTab';
import AuthorityChainsTab from '../components/knowledge-library/AuthorityChainsTab';
import FrameworkAnalysisTab from '../components/knowledge-library/FrameworkAnalysisTab';

const TABS = ['Overview', 'Standards & XBRL', 'Resolution Patterns', 'Authority Chains', 'Framework Analysis'] as const;
type Tab = typeof TABS[number];

export default function KnowledgeLibrary() {
  const [activeTab, setActiveTab] = useTabState<Tab>('tab', TABS, 'Overview');

  return (
    <PageLayout
      title="Knowledge Library"
      subtitle="Accounting standards, XBRL taxonomy, resolution patterns, and authority chains"
    >
      <TabBar
        tabs={TABS.map(t => ({ key: t, label: t }))}
        active={activeTab}
        onChange={v => setActiveTab(v as Tab)}
      />
      {activeTab === 'Overview' && <OverviewTab />}
      {activeTab === 'Standards & XBRL' && <StandardsXBRLTab />}
      {activeTab === 'Resolution Patterns' && <ResolutionPatternsTab />}
      {activeTab === 'Authority Chains' && <AuthorityChainsTab />}
      {activeTab === 'Framework Analysis' && <FrameworkAnalysisTab />}
    </PageLayout>
  );
}
